import { gql } from 'graphql-tag'

export default gql`
  fragment PageContactThankYouFragment on PageContactThankYou {
    sys {
      id
    }
  }
`
